/**
 * The ONE length limit for an operator assertion (`oa1.…`), shared by the API
 * that signs and verifies it and by every request schema that carries one in
 * a body field.
 *
 * A SESSION assertion carries every permission code its operator holds, so its
 * length grows with the permission catalog: a House of Pho manager's token is
 * ~4,850 characters. The limit was raised from 4096 to 8192 on 2026-10-02 in
 * the verifier alone, while four request schemas kept their own hand-typed
 * 4096 — so on 2026-11-04 production refused every till's tax exemption with
 * `body/requestedByAssertion must NOT have more than 4096 characters`, before
 * the handler ran. A schema that caps an assertion must use this constant,
 * never a literal (`operatorAssertionLimits.test.ts` in apps/api pins it).
 */
export const OPERATOR_ASSERTION_MAX_LENGTH = 8192;
